<template>
  <div id="bejelentkezes" class="wrapper wrapper--fluid">
    <section class="grid">
      <login-cards :pull-up="true"></login-cards>
    </section>

    <router-view></router-view>
  </div>
</template>
<script>
  import LoginCards from './Auth/LoginCards.vue'

  export default {
    components: {
      LoginCards
    }
  }
</script>

<style scoped>
.grid {
  max-width: 900px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?18ec9452